import { ThemeOptions } from "@mui/material";
import themeConfig from "./theme";

const darkThemeConfig: ThemeOptions = {
    ...themeConfig,
    palette: {
        ...themeConfig.palette,
        mode: "dark",
        background: {
            paper: "#1e293b",
            default: "#0f172a",
        },
        common: {
            black: "#eef4ff",
            white: "#111827",
        },
        primary: {
            main: "#3b82f6",
            light: "#93c5fd",
            dark: "#2563eb",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "#8b5cf6",
            light: "#c4b5fd",
            dark: "#7c3aed",
            contrastText: "#ffffff",
        },
        info: {
            main: "#0ea5e9",
            light: "#7dd3fc",
            dark: "#0284c7",
            contrastText: "#ffffff",
        },
        warning: {
            main: "#ca8a04",
            light: "#fde047",
            dark: "#5e3f00",
            contrastText: "#ffffff",
        },
        success: {
            main: "#22c55e",
            light: "#86efac",
            dark: "#15803d",
            contrastText: "#ffffff",
        },
        error: {
            main: "#EF4444",
            light: "#F87171",
            dark: "#DC2626",
            contrastText: "#ffffff",
        },
        text: {
            primary: "#eef4ff",
            secondary: "#9ca3af",
        },
        palmas: {
            subtle: 'rgba(255, 255, 255, 0.08)',
            textLight: '#9ca3af',
            textDark: '#ffffff'
        },
        action: {
            hover: 'rgba(255, 255, 255, 0.08)'
        }
    },
    components: {
        ...themeConfig.components,
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#9ca3af',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    },
                    '&.Mui-disabled': {
                        color: 'rgba(255, 255, 255, 0.3)',
                    },
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: 'inherit',
                },
            },
        },
        MuiButton: {
            ...themeConfig.components?.MuiButton,
            styleOverrides: {
                root: {
                    textTransform: "none" as const,
                    borderRadius: "8px",
                    fontWeight: 500,
                    transition: "all 0.2s ease-in-out",
                    '&.status-pending': {
                        backgroundColor: 'rgba(245, 158, 11, 0.1)',
                        color: '#f59e0b',
                        '&:hover': {
                            backgroundColor: 'rgba(245, 158, 11, 0.2)',
                        }
                    },
                    '&.status-completed': {
                        backgroundColor: 'rgba(16, 185, 129, 0.1)',
                        color: '#10b981',
                        '&:hover': {
                            backgroundColor: 'rgba(16, 185, 129, 0.2)',
                        }
                    }
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-filled': {
                        color: '#ffffff',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        transition: 'all 0.2s ease-in-out',
                        backgroundColor: "#1e293b",
                        '&:hover': {
                            borderColor: '#3b82f6',
                        },
                        '&.Mui-focused': {
                            boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.2)',
                        },
                    },
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    },
                    '& .MuiListItemIcon-root': {
                        color: 'inherit',
                        minWidth: 36
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: 'inherit'
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.2), 0 1px 2px rgba(0,0,0,0.2)",
                    '&.todo-item': {
                        backgroundColor: '#1e293b',
                        borderRadius: '8px',
                        transition: 'all 0.2s ease',
                        border: '1px solid',
                        borderColor: 'rgba(255, 255, 255, 0.08)',
                        '&:hover': {
                            backgroundColor: '#1e293b',
                            borderColor: 'rgba(255, 255, 255, 0.12)',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2), 0 2px 10px rgba(0,0,0,0.2)',
                        },
                    },
                },
            },
        },
    },
};

export default darkThemeConfig; 